import { createReducer, on } from "@ngrx/store";
import { loadNotifications, loadNotificationsError, loadNotificationsSuccess } from "./notifications.actions";
import { initialUserNotificationsState } from "./notifications.state";
import { NotificationsResponse } from "../interfaces/notifications.interface";

export const notificationsReducer = createReducer(
  initialUserNotificationsState,
  on(loadNotifications, (state): NotificationsResponse => ({ ...state })),
  on(loadNotificationsSuccess, (state, { response }): NotificationsResponse => ({ 
    ...state,
    pagination: response.pagination,
    userNotifications: response.userNotifications
  })),
  on(loadNotificationsError, (state, { error }): NotificationsResponse => ({ 
    ...state,
    pagination: null,
    userNotifications: null
  })),
);
